// extracted by mini-css-extract-plugin
module.exports = {"drawerBackdrop":"_123eb9","hideSidebar":"_05b5d0","drawerPaper":"_7e6dca","drawerTypography":"_e30190"};